module.exports = __webpack_public_path__ + "static/NotoSerif-BoldItalic-277f6591a710462b220c071ec85bb124.woff2";